import { Toast, DialogPlugin } from "tdesign-mobile-vue";
import moment from "moment";
import Clipboard from "clipboard";

export const app_url = import.meta.env.MODE == "test" ? "https://hdtest.xieguangcheng.com//help/#/" : "https://help.xiao5.cn/help/#/";
export function isWeixin() {
  var ua = navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == "micromessenger") {
    return true;
  } else {
    return false;
  }
}
// 判断当前微信版本号是否支持
export function is_version() {
  let client = false; // 当前版本号是否支持 (默认不支持)
  let wxInfo = navigator.userAgent.match(/MicroMessenger\/([\d\.]+)/i); // 微信浏览器信息
  if (wxInfo == null) {
    return client;
  } else {
    // 微信版本号 wxInfo[1] = "7.0.18.1740" (示例)
    // 使用标准的逐段比较方式，避免 7.1.x 等版本漏检
    let version = wxInfo[1].split(".").map(Number);
    let target = [7, 0, 12]; // 最低支持版本
    for (let i = 0; i < target.length; i++) {
      let v = version[i] || 0;
      if (v > target[i]) { client = true; break; }
      if (v < target[i]) { break; }
      if (i === target.length - 1) { client = true; } // 完全相等也支持
    }
    return client;
  }
}
export function isApp() {
  const ua = window.navigator.userAgent.toLowerCase();
  return ua.indexOf("changguan") !== -1;
}

export function checkApp() {
  if (!isApp()) {
    DialogPlugin.alert({
      title: "温馨提示",
      content: "请前往常观APP打开此页",
      confirmBtn: "确定",
      onConfirm: () => {
        window.location.href = "https://sharekcz.cztv.tv/openApp?redirect_url=" + encodeURIComponent(window.location.href);
      },
    });
    return false;
  }
  return true;
}
export function isIos() {
  var u = navigator.userAgent;
  var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
  var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  if (isiOS) {
    return true;
  } else {
    return false;
  }
}

export function wechatTitle(title) {
  document.title = title;
  var mobile = navigator.userAgent.toLowerCase();
  if (/iphone|ipad|ipod/.test(mobile)) {
    var iframe = document.createElement("iframe");
    iframe.style.display = "none";
    // 替换成站标favicon路径或者任意存在的较小的图片即可
    iframe.setAttribute("src", "/favicon.ico");
    var iframeCallback = function () {
      setTimeout(function () {
        iframe.removeEventListener("load", iframeCallback);
        document.body.removeChild(iframe);
      }, 0);
    };
    iframe.addEventListener("load", iframeCallback);
    document.body.appendChild(iframe);
  }
}
/**
 *
 * @param {*} value
 * @returns
 */
export const longTime = (value) => {
  if (value === "") {
    return "";
  }
  return moment(value).format("YYYY-MM-DD HH:mm:ss");
};
/**
 *
 * @param {*} value
 * @returns
 */
export const shortTime = (value) => {
  if (value === "") {
    return "";
  }
  return moment(value).format("YYYY-MM-DD");
};

/**
 * 获取时间戳
 * @param {*} value
 * @returns
 */
export const getTime = (value) => {
  if (value === "") {
    return "";
  }
  return moment(value).valueOf();
};
/**
 * 数字转成汉字
 * @params num === 要转换的数字
 * @return 汉字
 * */
export function toChinesNum(num) {
  let changeNum = ["零", "一", "二", "三", "四", "五", "六", "七", "八", "九"];
  let unit = ["", "十", "百", "千", "万"];
  num = parseInt(num);
  let getWan = (temp) => {
    let strArr = temp.toString().split("").reverse();
    let newNum = "";
    let newArr = [];
    strArr.forEach((item, index) => {
      newArr.unshift(item === "0" ? changeNum[item] : changeNum[item] + unit[index]);
    });
    let numArr = [];
    newArr.forEach((m, n) => {
      if (m !== "零") numArr.push(n);
    });
    if (newArr.length > 1) {
      newArr.forEach((m, n) => {
        if (newArr[newArr.length - 1] === "零") {
          if (n <= numArr[numArr.length - 1]) {
            newNum += m;
          }
        } else {
          newNum += m;
        }
      });
    } else {
      newNum = newArr[0];
    }

    return newNum;
  };
  let overWan = Math.floor(num / 10000);
  let noWan = num % 10000;
  if (noWan.toString().length < 4) {
    noWan = "0" + noWan;
  }
  return overWan ? getWan(overWan) + "万" + getWan(noWan) : getWan(num);
}

/**
 * 加 +
 * @param num1
 * @param num2
 * @returns {number}
 */
export function accAddition(num1, num2) {
  const num1Digits = (num1.toString().split(".")[1] || "").length;
  const num2Digits = (num2.toString().split(".")[1] || "").length;
  const baseNum = Math.pow(10, Math.max(num1Digits, num2Digits));
  return (Math.round(num1 * baseNum) + Math.round(num2 * baseNum)) / baseNum;
}

/**
 * 减 -
 * @param num1
 * @param num2
 * @returns {number}
 */
export function accSubtract(num1, num2) {
  const num1Digits = (num1.toString().split(".")[1] || "").length;
  const num2Digits = (num2.toString().split(".")[1] || "").length;
  const baseNum = Math.pow(10, Math.max(num1Digits, num2Digits));
  return (Math.round(num1 * baseNum) - Math.round(num2 * baseNum)) / baseNum;
}

/**
 * 乘 *
 * @param num1
 * @param num2
 * @returns {number}
 */
export function accMultiply(num1, num2) {
  const num1Digits = (num1.toString().split(".")[1] || "").length;
  const num2Digits = (num2.toString().split(".")[1] || "").length;
  const baseNum = Math.pow(10, Math.max(num1Digits, num2Digits));
  return (Math.round(num1 * baseNum) * Math.round(num2 * baseNum)) / baseNum / baseNum;
}

/**
 * 除 /
 * @param num1
 * @param num2
 * @returns {number}
 */
export function accDivision(num1, num2) {
  const num1Digits = (num1.toString().split(".")[1] || "").length;
  const num2Digits = (num2.toString().split(".")[1] || "").length;
  const baseNum = Math.pow(10, Math.max(num1Digits, num2Digits));
  return Math.round(num1 * baseNum) / Math.round(num2 * baseNum);
}
/**
 * 复制
 * @param {*} text
 */
export function copyText(dom) {
  let clipboard = new Clipboard(`.${dom}`);
  clipboard.on("success", () => {
    clipboard.destroy();
    Toast("复制成功");
  });
  clipboard.on("error", () => {
    console.log("error");
    clipboard.destroy();
  });
}
/**
 * 去标签
 * @param {*} str
 * @returns
 */
export function removeHtmlTags(str) {
  if (!str) return "";
  return str.replace(/<[^>]*>/g, "");
}
/**
 * 获取 URL query 参数
 * @param {string} name 参数名
 * @returns {string|null}
 */
export function getQueryString(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) {
    return decodeURIComponent(r[2]);
  }
  return null;
}
